export enum FeeActionType {
  FeesApprovedInsideCommitment = 'FeesApprovedInsideCommitment',
  FeesApprovedOutsideCommitment = 'FeesApprovedOutsideCommitment',
}

export const FeeActionTypeLabels = {
  [FeeActionType.FeesApprovedInsideCommitment]: 'Inside Commitment',
  [FeeActionType.FeesApprovedOutsideCommitment]: 'Outside Commitment',
};
